const image1 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers.webp"
const freshers_asso_logo = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/clubs/fresherslogo.webp"
const image2 = require("../assets/FRESHERS_2.jpg");
const image3 = require("../assets/FRESHERS_3.jpg");

const freshers_asso_heroimage_carousalinfo = {
    id: 1,
    title: "Freshers' Association of ACGCET",
    img_list: [image1, image2, image3],
};
const freshers_events = [
    {
        'id': '1',
        'date': 'SEP 20 2025',
        'title': "ARDUINO WORKSHOP - by Freshers' Association of ACGCET",
        'time': '10:00 am',
        'venue': 'Gallery Hall',
        'details': 'A workshop on Arduino to enhance technical skills',

    },
    {
        'id': '2',
        'date': 'SEP 09 2025',
        'title': "Freshers Party - by Freshers' Association of ACGCET",
        'time': '09:30 am',
        'venue': 'Murugappa Hall',
        'details': 'An exclusive party for freshers',
        //  'status':'due'
    },
    {
        'id': '8',
        'date': 'AUG 11 2025',
        'title': "Campus Tour for Freshers by Freshers Association of ACGCET",
        'time': '09:20 am',
        'venue': 'ACGCET campus',
    },
    {
        'id': '7',
        'date': 'AUG 11 - AUG 19 2025',
        'title': "Freshers' Welcome & Induction Programme",
        'time': '09:20 am',
        'venue': 'Murugappa Hall',
    },
];



const mission_data = [
    {
        id: '1',
        mission: 'To provide a structured approach for developing and executing innovative projects and start-up ideas.'
    },
    {
        id: '2',
        mission: 'To ensure clear visibility of progress and milestones in entrepreneurial ventures.'
    },
    {
        id: '3',
        mission: 'To help students set priorities effectively in order to manage multiple projects and opportunities.'
    },
    {
        id: '4',
        mission: 'To enhance professional skills such as business planning, market research, and networking.'
    }

]
const vision = {
    id: '1',
    visiondata: 'To nurture and empower the next generation of innovators and entrepreneurs by providing a supportive and resource-rich environment that transforms ideas into sustainable ventures.'
};

const Objective = [
    {
        id: '1',
        point: 'To guide freshers in adapting to college life through mentorship and peer support.'
    },
    {
        id: '2',
        point: 'To organize workshops, seminars, and interactive sessions for skill development and confidence building.'
    },
    {
        id: '3',
        point: 'To encourage participation in cultural, technical, and sports events for holistic growth.'
    },
    {
        id: '4',
        point: 'To foster a sense of belonging and camaraderie among all first-year students.'
    },
    {
        id: '5',
        point: 'To provide a platform for freshers to express their ideas, talents, and aspirations.'
    },

]


const freshersmenu = [
    {
        id: "1",
        path: "/freshers_asso",
        link: "About",
        arl: "l",
    },
    {
        id: "2",
        path: "/freshers_workshops",
        link: "Workshops",
        arl: "l",
    },
    // {
    //     id: "3",
    //     path: "/freshers_asso",
    //     link: "Gallery",
    //     arl: "l",
    // },

]


const freshers_workshops = [
    
    {
        id: "1",
        heading: "Arduino Workshop",
        date: "20.09.2025",
        // organizer: "Alagappa Incubation Forum, ACGCET",
        content: "The Fresher's Association of ACGCET organised an Arduino Workshop to enhance technical skills among students. This workshop will cover the basics of Arduino programming, circuit design, and hands-on projects. Participants will have the opportunity to learn how to create interactive electronic devices and develop their own innovative projects using Arduino technology.",
        images: [
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/AW_1.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/AW_2.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/AW_4.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/AW_3.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/AW_5.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/AW_6.webp",
        ]
    }, {
        id: "2",
        heading: "Graphic Design Workshop",
        date: "15.10.2025",
        // organizer: "Alagappa Incubation Forum, ACGCET",
        content :"The Freshers' Association of ACGCET organized a Graphic Design Workshop to introduce students to the fundamentals of graphic design, including principles, tools, and techniques for creating visually appealing content. The session also included a hands-on practice segment where participants explored design tools and created simple graphics to enhance their creativity and design skills.",
        images: [
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/GD_1.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/GD_2.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/GD_5.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/GD_6.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/GD_3.webp",
        ]

    },
    {
        id: "3",
        heading: "Python Workshop",
        date: "26.10.2025",
        // organizer: "Alagappa Incubation Forum, ACGCET",
        content: "The Fresher's Association of ACGCET organised python workshop to enhance their problem solving skills and real time coding knowledge along with  a practice session that build a strong foundation in python programmming.The workshop also provided participants with practical exercises to apply their learning and improve their programming confidence.",
        images: [
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/py1.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/py2.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/py3.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/py4.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/py5.webp",
        ]

    },
    
    {
        id: "4",
        heading: "PPT Workshop",
        date: "17.02.2026",
        // organizer: "Alagappa Incubation Forum, ACGCET",
        content:"A PPT workshop was organised to improve students' presentation skills and enhance their ability to create effective visual content. The session introduced participants to essential features of Microsoft PowerPoint, including slide design, animations, transitions, and content structuring.The workshop also included a hands-on session where students created their own presentations to apply the concepts learned.",
        images: [
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/ppt2.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/ppt3.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/ppt4.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/ppt5.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/ppt1.webp",
        ]

    },
     {
        id: "5",
        heading: "Resume Building Workshop",
        date: "24.02.2026",
        // organizer: "Alagappa Incubation Forum, ACGCET",
        content:"A Resume Building Workshop was organized to help students to learn how to create effective and professional resumes. The session covered resume structure, key sections, formatting tips, and common mistakes to avoid. Participants also practiced building their own resumes to better prepare for internships and job opportunities.",
        images: [
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/resume1.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/resume2.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/resume3.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/resume4.webp",
            "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/clubs/Freshers_asso/resume5.webp",
        ]

    }
   
]
export {
    freshers_asso_logo,
    freshers_asso_heroimage_carousalinfo,
    mission_data,
    vision,
    Objective,
    freshers_events,
    freshersmenu,
    freshers_workshops,
}